import { motion } from "framer-motion";
import { Eyebrow, PrimaryButton, GhostButton } from "@/components/ui-bits";

const ServicesHero = () => {
  return (
    <section data-testid="services-hero" aria-labelledby="services-hero-heading" className="relative overflow-hidden bg-white">
      <div className="grid lg:min-h-[560px] lg:grid-cols-12">
        <div className="container-30 flex items-center py-16 sm:py-20 lg:col-span-6 lg:py-24 lg:pr-0">
          <div className="max-w-xl">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}>
              <Eyebrow>Transportation Solutions</Eyebrow>
            </motion.div>
            <motion.h1
              id="services-hero-heading"
              data-testid="services-hero-headline"
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 text-4xl font-black leading-[1.02] tracking-tight text-[#191c1e] sm:text-5xl lg:text-[2.5rem] xl:text-6xl"
            >
              TRANSPORTATION BUILT AROUND YOUR FREIGHT.
            </motion.h1>
            <motion.p
              data-testid="services-hero-subcopy"
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 text-base leading-relaxed text-[#5f666d] sm:text-lg"
            >
              From full and partial loads to dedicated transportation, expedited shipments and specialized delivery, 30
              NORTH provides flexible transportation solutions designed around your shipment requirements.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center"
            >
              <PrimaryButton to="/request-a-quote" testid="services-hero-primary-cta" className="w-full sm:w-auto">
                REQUEST A QUOTE
              </PrimaryButton>
              <GhostButton to="/capacity" testid="services-hero-secondary-cta" className="w-full sm:w-auto">
                EXPLORE OUR CAPACITY
              </GhostButton>
            </motion.div>
          </div>
        </div>
        <div className="relative h-72 sm:h-96 lg:col-span-6 lg:h-auto">
          <motion.img
            src="/assets/services-hero.webp"
            alt="A 30 NORTH branded tractor and dry van trailer in an active Ontario distribution yard with a forklift handling palletized freight"
            data-testid="services-hero-image"
            initial={{ opacity: 0, scale: 1.04 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-y-0 left-0 hidden w-24 bg-gradient-to-r from-white to-transparent lg:block" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
